export const articles = [
  {
    id: "timeline-full",
    title: "灵灵事件完整时间线：从起因到最新进展的关键节点",
    category: "progress",
    author: "本站编辑部",
    date: "2026-09-08",
    readTime: "9 分钟",
    excerpt:
      "把散落在各个平台的片段按时间重新排列后，事件脉络其实比想象中清晰。本文按日期梳理每一个可核验节点，并标注每条信息的可信等级。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20conceptual%20illustration%2C%20warm%20cream%20paper%20background%2C%20deep%20burgundy%20and%20ochre%20gold%20geometric%20timeline%20shapes%2C%20minimal%20magazine%20cover%20art%2C%20subtle%20grain%20texture%2C%20flat%20vector%2C%20no%20text%2C%20no%20people&width=1200&height=800&seq=ll-timeline-a1&orientation=landscape",
    tags: ["时间线", "事件梳理", "后续进展"],
    infoLevel: "已证实",
    featured: true,
    content: [
      {
        type: "p",
        text: "争议爆发后，信息以碎片形式散落在短视频、超话与匿名论坛之间，很多人只看到其中一段就被推动着下结论。本文的做法很简单：把能确认发布时间的公开信息按顺序排列，让脉络自己浮现出来。",
      },
      { type: "h2", text: "一、起点：一段被剪辑的直播片段" },
      {
        type: "p",
        text: "8 月 27 日，一段长度不足四十秒的直播片段被剪成短视频。片段本身没有完整语境，但配上的标题带有明显导向性，这让它在短时间内完成了首次大规模传播。值得注意的是，原始直播回放当时仍可查证。",
      },
      { type: "h2", text: "二、回应期：声明与二次说明" },
      {
        type: "p",
        text: "8 月 29 日工作室发布声明，否认了其中最严重的指控；9 月 3 日当事人补充说明，承认部分表达造成误解。这两次回应构成了事件的第一阶段，也是目前唯一有明确发布主体与时间的信息。",
      },
      {
        type: "list",
        items: [
          "8 月 29 日：工作室文字声明，否认核心指控并表示已取证",
          "9 月 1 日：多组匿名爆料集中出现，来源无法核实",
          "9 月 3 日：当事人二次回应，对部分细节作补充解释",
        ],
      },
      { type: "h2", text: "三、爆发期：匿名爆料与平台处理" },
      {
        type: "p",
        text: "9 月 1 日前后出现的所谓聊天记录，是让讨论彻底失控的关键。这些内容缺少来源说明，且时间戳与当事人公开行程存在矛盾。9 月 5 日起，多个平台对明显失实的搬运内容做了限制推荐处理。",
      },
      { type: "h2", text: "四、当前阶段：从对线转向核查" },
      {
        type: "p",
        text: "9 月 8 日之后，讨论的主流开始从情绪对线转向证据核对，已经出现若干条被证伪的所谓「实锤」。这是事件从舆论阶段走向信息核验阶段的重要信号。",
      },
      {
        type: "quote",
        text: "时间线最大的价值不是还原真相，而是让你看清：哪些说法在什么时候出现，又是在什么背景下被放大的。",
      },
      { type: "h2", text: "五、如何继续跟进" },
      {
        type: "p",
        text: "建议只关注有明确发布主体与发布时间的信息源。对于匿名爆料，先记录其出现时间，再与公开行程比对，而不是立刻转发。本站会持续更新本条时间线，并在每条信息旁标注可信等级。",
      },
    ],
    related: ["three-types", "platform-notice", "stage-two"],
  },
  {
    id: "response-five-points",
    title: "灵灵本人回应全文要点：这五点最值得看",
    category: "response",
    author: "本站编辑部",
    date: "2026-09-07",
    readTime: "7 分钟",
    excerpt:
      "回应全文并不长，但被转发时往往只剩下一句话。我们把原文拆成五个要点，同时标出回应中刻意模糊、没有正面回答的部分。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20conceptual%20illustration%2C%20warm%20cream%20paper%20background%2C%20burgundy%20megaphone%20and%20gold%20quote%20marks%20geometric%20shapes%2C%20minimal%20magazine%20cover%20art%2C%20subtle%20grain%2C%20flat%20vector%2C%20no%20text%2C%20no%20people&width=1200&height=800&seq=ll-response-b2&orientation=landscape",
    tags: ["本人回应", "声明", "要点提炼"],
    infoLevel: "已证实",
    featured: true,
    content: [
      {
        type: "p",
        text: "当事人的回应读起来情绪克制，但信息密度并不低。真正容易在转发中丢失的，是「哪些说了、哪些没说」。下面按原文顺序整理出五个要点。",
      },
      { type: "h2", text: "要点一：明确否认核心指控" },
      {
        type: "p",
        text: "回应开篇直接否认了传播最广的两项指控，用词为「完全不属实」。这是整份回应中态度最明确的一段，也是后续讨论的主要锚点。",
      },
      { type: "h2", text: "要点二：承认部分表达造成误解" },
      {
        type: "p",
        text: "与否认并列的是对表达方式的自我检讨。当事人承认直播中的某些措辞会引起误读，并为「表达不严谨」致歉。注意，这里道歉的对象是表达方式，而不是指控本身。",
      },
      { type: "h2", text: "要点三：解释而非逐条反驳" },
      {
        type: "p",
        text: "对于流传的聊天记录，回应选择解释背景，而非逐条比对时间戳。这种处理方式降低了对抗性，但也留下了「没有正面回应细节」的空间。",
      },
      { type: "h2", text: "要点四：提到法律途径" },
      {
        type: "p",
        text: "回应结尾表示相关内容已取证，会交由法律途径处理。这是保护性表述，并不意味着任何一方已被认定存在不当行为。",
      },
      { type: "h2", text: "要点五：没有回应的部分" },
      {
        type: "list",
        items: [
          "未逐条说明被指聊天记录的具体来源",
          "未公布所谓取证材料的内容",
          "未就事件对合作方的影响作出说明",
        ],
      },
      {
        type: "quote",
        text: "读回应时，先看它承认了什么，再看它回避了什么——回避的部分，通常是下一轮争议的起点。",
      },
      {
        type: "p",
        text: "整体来看，这份回应完成了「否认核心指控 + 软化表达争议」的双重目标，但对细节类疑问保持了距离。理解这一点，比急着给回应打分更有用。",
      },
    ],
    related: ["second-response", "statement-read", "fans-vs-public"],
  },
  {
    id: "chat-record-fake",
    title: "被疯传的「聊天记录」是真是假？辟谣视角逐条拆解",
    category: "debunk",
    author: "事实核查组",
    date: "2026-09-05",
    readTime: "11 分钟",
    excerpt:
      "这组截图是整起事件传播最广的材料，也是漏洞最多的材料。我们从来源、时间戳、界面细节三个角度逐条拆解，说明为什么它只能被归入「待确认」。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20conceptual%20illustration%2C%20warm%20cream%20paper%20background%2C%20burgundy%20magnifying%20glass%20over%20geometric%20chat%20bubbles%2C%20gold%20accents%2C%20minimal%20magazine%20cover%20art%2C%20subtle%20grain%2C%20flat%20vector%2C%20no%20text%2C%20no%20people&width=1200&height=800&seq=ll-debunk-c3&orientation=landscape",
    tags: ["辟谣分析", "聊天记录", "事实核查"],
    infoLevel: "待确认",
    featured: true,
    content: [
      {
        type: "p",
        text: "在信息冲击力最强的材料面前，最容易被忽略的恰恰是它的来源。这组被反复转发的聊天记录，几乎每一次转发都丢失了「原始出处」这一行字。",
      },
      { type: "h2", text: "漏洞一：来源只有「朋友的朋友」" },
      {
        type: "p",
        text: "所有版本最终都指向同一个模糊说法——「内部人士提供」。没有原始设备、没有导出记录、没有可追溯的第一发布者。这类材料在核查标准中无法进入「已证实」层级。",
      },
      { type: "h2", text: "漏洞二：时间戳与公开行程矛盾" },
      {
        type: "list",
        items: [
          "截图中显示的一段对话时间，当事人正在公开直播，时间线无法同时成立",
          "多个版本对同一段对话标注的日期并不一致",
          "部分截图显示的昵称在同一账号下前后不同",
        ],
      },
      { type: "h2", text: "漏洞三：界面细节不自然" },
      {
        type: "p",
        text: "逐帧放大后可以看到，对话框的行距与字体渲染与官方客户端存在差异，个别气泡边缘有拼接痕迹。这些还不能直接证明伪造，但足以说明该材料需要更严格的取证。",
      },
      { type: "h2", text: "为什么它还是被信了" },
      {
        type: "p",
        text: "因为它恰好符合很多人已有的预期。当一段材料与预设立场吻合时，人们会跳过核实这一步，这叫动机性推理。它不是某个群体独有的问题，而是所有人的默认倾向。",
      },
      {
        type: "quote",
        text: "判断一张截图，先问它是谁在什么时候第一次发出来的。找不到这个问题答案的材料，都不该被当成结论。",
      },
      { type: "h2", text: "结论与信息等级" },
      {
        type: "p",
        text: "综合来源、时间戳与界面细节三方面，本站将流传最广的这组聊天记录标注为「待确认」——既不能确认为真，也没有足够证据断言为假。请勿将其作为定论传播。",
      },
    ],
    related: ["three-types", "timeline-full", "fans-vs-public"],
  },
  {
    id: "statement-read",
    title: "工作室声明逐句解读：哪些表述留有余地",
    category: "statement",
    author: "本站编辑部",
    date: "2026-09-06",
    readTime: "8 分钟",
    excerpt:
      "一份两百多字的声明，真正的信息往往藏在措辞的分寸里。「保留追究权利」「部分内容失实」这些表述，和公众理解的意思并不完全相同。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20conceptual%20illustration%2C%20warm%20cream%20paper%20background%2C%20burgundy%20document%20sheets%20with%20gold%20seal%20geometric%20shapes%2C%20minimal%20magazine%20cover%20art%2C%20subtle%20grain%20texture%2C%20flat%20vector%2C%20no%20text%2C%20no%20people&width=1200&height=800&seq=ll-statement-d4&orientation=landscape",
    tags: ["声明解读", "措辞", "法律表述"],
    infoLevel: "已证实",
    content: [
      {
        type: "p",
        text: "声明类文本的写作逻辑，和日常表达并不一样。它的目标不是说服读者，而是在保留法律空间的前提下完成表态。因此每一个限定词都值得读慢一点。",
      },
      { type: "h2", text: "「部分内容失实」不等于「全部失实」" },
      {
        type: "p",
        text: "这个表述只否定了「部分」，意味着声明方并未整体否认所有流传信息。与「均为恶意造谣」相比，这是一句留了退路的措辞。",
      },
      { type: "h2", text: "「保留追究权利」不等于「已经起诉」" },
      {
        type: "p",
        text: "保留权利是声明中最常见的收尾方式，它表示立场，不代表程序已经启动。真正有分量的后续动作，是正式立案或起诉的公开信息。",
      },
      { type: "h2", text: "「已取证」需要看取证层级" },
      {
        type: "list",
        items: [
          "自行截图保存，属于最基础的固定证据",
          "时间戳存证或公证，效力更高",
          "司法鉴定，通常只在争议进入程序后才出现",
        ],
      },
      { type: "h2", text: "声明中缺失的三件事" },
      {
        type: "p",
        text: "没有公布取证清单，没有给出具体的失实条目，也没有说明对合作方与粉丝的后续安排。这三处空白，正是后续讨论持续发酵的原因。",
      },
      {
        type: "quote",
        text: "读声明时把「表态」和「事实」分开：前者是写给人看的，后者才需要证据支撑。",
      },
      {
        type: "p",
        text: "整体而言，这是一份态度明确、细节保守的声明。它完成了危机公关的第一步，但没有为公众提供可核验的信息增量。",
      },
    ],
    related: ["statement-word", "response-five-points", "platform-notice"],
  },
  {
    id: "three-types",
    title: "事实、观点还是传闻？灵灵事件三类信息辨读指南",
    category: "debunk",
    author: "事实核查组",
    date: "2026-09-04",
    readTime: "6 分钟",
    excerpt:
      "同一件事里同时存在三类内容：可以核验的事实、带有立场的观点、以及来源不明的传闻。学会给信息贴标签，是这场讨论里最实用的技能。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20conceptual%20illustration%2C%20warm%20cream%20paper%20background%2C%20three%20burgundy%20gold%20sage%20geometric%20columns%20of%20different%20heights%2C%20minimal%20magazine%20cover%20art%2C%20subtle%20grain%2C%20flat%20vector%2C%20no%20text%2C%20no%20people&width=1200&height=800&seq=ll-threetypes-e5&orientation=landscape",
    tags: ["辟谣分析", "信息分级", "方法"],
    infoLevel: "已证实",
    content: [
      {
        type: "p",
        text: "在争议事件里，把三类信息混为一谈是最常见的问题。它们被同样的语气说出来，但需要的信任成本完全不同。",
      },
      { type: "h2", text: "第一类：事实" },
      {
        type: "p",
        text: "有明确发布主体、可追溯发布时间、内容可被第三方核验的信息。例如工作室声明的存在、平台对某类内容的处理结果。事实也可能被误读，但至少可以被检验。",
      },
      { type: "h2", text: "第二类：观点" },
      {
        type: "p",
        text: "基于事实的推断与评价，比如「这个回应太模糊」「他的态度不够诚恳」。观点本身没有问题，问题在于把它当成事实来引用。",
      },
      { type: "h2", text: "第三类：传闻" },
      {
        type: "p",
        text: "来源不明、无法追溯首发者、内容无法核验的信息。它在传播中会被反复转述，逐渐获得「好像很多人都这么说」的可信度错觉。",
      },
      {
        type: "list",
        items: [
          "贴标签：看到一条信息先问它属于哪一类",
          "找首发：追溯第一发布者与发布时间",
          "交叉验证：换一个独立来源核对同一件事",
          "承认不确定：无法判断时，保留判断而不是替代它",
        ],
      },
      {
        type: "quote",
        text: "怀疑不是目的，可核验的怀疑才是。对每一条信息都问一句「这话是谁说的、什么时候说的、能不能查」，就已经比大多数人更接近判断。",
      },
    ],
    related: ["chat-record-fake", "fans-vs-public", "timeline-full"],
  },
  {
    id: "second-response",
    title: "二次回应为何反而引发更多质疑",
    category: "response",
    author: "本站编辑部",
    date: "2026-09-03",
    readTime: "7 分钟",
    excerpt:
      "第二次回应比第一次更温和，按理说应该降温，结果讨论反而更激烈。问题出在回应的「目标」与公众的「期待」并不一致。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20conceptual%20illustration%2C%20warm%20cream%20paper%20background%2C%20burgundy%20speech%20bubble%20and%20gold%20ripple%20circles%2C%20minimal%20magazine%20cover%20art%2C%20subtle%20grain%20texture%2C%20flat%20vector%2C%20no%20text%2C%20no%20people&width=1200&height=800&seq=ll-second-f6&orientation=landscape",
    tags: ["本人回应", "公关", "二次回应"],
    infoLevel: "已证实",
    content: [
      {
        type: "p",
        text: "危机沟通里有一条经验：第二次表态如果只是在第一次的基础上加情绪、不加信息，往往会放大而不是平息争议。",
      },
      { type: "h2", text: "目标错位：想降温，读者想求证" },
      {
        type: "p",
        text: "回应的目标是让事件降温，但公众真正想要的是可核验的细节。当双方目标不一致时，任何示弱都会被解读为回避。",
      },
      { type: "h2", text: "新增的情绪信息，挤掉了事实信息" },
      {
        type: "p",
        text: "第二次回应增加了不少情绪化描述，篇幅被情绪占满，反而没有比第一次多出多少可核验内容。读者的感受是「说了很多，但没说清楚」。",
      },
      { type: "h2", text: "时机也让效果打折" },
      {
        type: "list",
        items: [
          "回应发布时，匿名爆料正处于传播高峰",
          "缺少第三方见证或材料佐证，说服力有限",
          "对上一轮疑问未作逐条回应，留有解释空间",
        ],
      },
      {
        type: "quote",
        text: "在舆论场上，情绪回应只能换来情绪回应；只有信息回应，才可能换来判断。",
      },
      {
        type: "p",
        text: "这并不意味着二次回应对当事人没有价值。它至少确立了「承认表达问题」的立场，为后续可能的沟通留出了空间。但从传播效果看，它确实没能止住讨论。",
      },
    ],
    related: ["response-five-points", "statement-read", "fans-vs-public"],
  },
  {
    id: "platform-notice",
    title: "平台公告怎么读：账号处理与内容下架不是一回事",
    category: "progress",
    author: "本站编辑部",
    date: "2026-09-02",
    readTime: "6 分钟",
    excerpt:
      "很多人把「内容被限制推荐」直接等同于「账号有问题」。这两种处理在平台规则里的含义差得很远，也直接决定了它能不能被当成事件定性的依据。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20conceptual%20illustration%2C%20warm%20cream%20paper%20background%2C%20burgundy%20and%20sage%20geometric%20grid%20panels%20with%20gold%20toggle%20shape%2C%20minimal%20magazine%20cover%20art%2C%20subtle%20grain%2C%20flat%20vector%2C%20no%20text%2C%20no%20people&width=1200&height=800&seq=ll-platform-g7&orientation=landscape",
    tags: ["后续进展", "平台规则", "公告"],
    infoLevel: "已证实",
    content: [
      {
        type: "p",
        text: "平台公告常被当作「官方定性」来引用，但大多数公告只处理内容层面的合规问题，并不对事实本身作出判断。",
      },
      { type: "h2", text: "三种常见处理，力度完全不同" },
      {
        type: "list",
        items: [
          "限制推荐：内容仍可查看，只是不进入推荐流",
          "内容下架：单条内容被移除，账号不受影响",
          "账号处置：禁言或封禁，属于最高一档",
        ],
      },
      { type: "h2", text: "为什么大多数时候只是限制推荐" },
      {
        type: "p",
        text: "因为平台的核心判断标准是「是否可能引发不实信息扩散」，而不是「谁对谁错」。这是一个风险管理逻辑，不是裁决逻辑。",
      },
      { type: "h2", text: "误读会带来什么" },
      {
        type: "p",
        text: "把内容处理读成账号定性，会让整个讨论建立在错误的前提上。更麻烦的是，一旦前提被推翻，先前的所有推论都要重来。",
      },
      {
        type: "quote",
        text: "平台公告回答的是「这条内容能不能被推荐」，不是「这个人有没有问题」。",
      },
      {
        type: "p",
        text: "9 月 5 日前后，多个平台对明显失实的搬运内容做了限制推荐处理，但当事人账号状态并未发生变化。这一点应当被准确记入时间线。",
      },
    ],
    related: ["timeline-full", "stage-two", "statement-read"],
  },
  {
    id: "fans-vs-public",
    title: "同一件事，粉丝和路人为什么看到完全不同",
    category: "debunk",
    author: "事实核查组",
    date: "2026-09-01",
    readTime: "6 分钟",
    excerpt:
      "争论到最后，双方常常连「在争论什么」都不一致。这不是谁更蠢的问题，而是信息源、判断标准与情绪立场三重差异叠加的结果。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20conceptual%20illustration%2C%20warm%20cream%20paper%20background%2C%20two%20opposing%20burgundy%20and%20sage%20geometric%20arrow%20groups%20with%20gold%20center%2C%20minimal%20magazine%20cover%20art%2C%20subtle%20grain%2C%20flat%20vector%2C%20no%20text%2C%20no%20people&width=1200&height=800&seq=ll-fans-h8&orientation=landscape",
    tags: ["辟谣分析", "舆论", "认知差异"],
    infoLevel: "已证实",
    content: [
      {
        type: "p",
        text: "理解分歧比争论对错更有价值。看清差异从哪来，你才能判断自己在哪一层。",
      },
      { type: "h2", text: "差异一：信息源不同" },
      {
        type: "p",
        text: "一部分人接触的是长期跟踪的内部信息，另一部分人接触到的是算法推来的高情绪片段。输入不同，结论自然不同。",
      },
      { type: "h2", text: "差异二：判断标准不同" },
      {
        type: "p",
        text: "一方默认「先相信当事人」，另一方默认「先要求证据」。两套标准本身没有对错，但会导致对同一份声明的评价完全相反。",
      },
      { type: "h2", text: "差异三：情绪立场不同" },
      {
        type: "p",
        text: "当你已经投入了情感，承认对方说法可能有道理，就等同于承认自己此前的投入被浪费了。这让很多人不愿更新判断。",
      },
      {
        type: "quote",
        text: "分歧的根源往往不在证据，而在证据之外：你从哪里看到它，你用什么标准衡量它，以及你希望它是什么。",
      },
      {
        type: "p",
        text: "想跳出这种循环，唯一可行的方式是先把三类差异摊开来说清楚，而不是继续用结论去攻击结论。",
      },
    ],
    related: ["three-types", "second-response", "chat-record-fake"],
  },
  {
    id: "stage-two",
    title: "事件进入第二阶段：从情绪对线转向证据核查",
    category: "progress",
    author: "本站编辑部",
    date: "2026-08-30",
    readTime: "5 分钟",
    excerpt:
      "当讨论开始出现时间戳比对、来源追溯这些动作时，事件就进入了另一个阶段。第二阶段的特征和第一阶段完全不同，关注重点也该跟着换。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20conceptual%20illustration%2C%20warm%20cream%20paper%20background%2C%20burgundy%20checklist%20and%20gold%20eyeglass%20geometric%20motif%2C%20sage%20accent%20blocks%2C%20minimal%20magazine%20cover%20art%2C%20subtle%20grain%2C%20flat%20vector%2C%20no%20text%2C%20no%20people&width=1200&height=800&seq=ll-stage-i9&orientation=landscape",
    tags: ["后续进展", "阶段分析", "核查"],
    infoLevel: "待确认",
    content: [
      {
        type: "p",
        text: "舆论事件通常有两个阶段：第一阶段比拼情绪与声量，第二阶段比拼信息与耐心。是否进入第二阶段，看的是讨论里出现了什么动作。",
      },
      { type: "h2", text: "第一阶段的三个特征" },
      {
        type: "list",
        items: [
          "传播速度快于核实速度",
          "结论先于证据出现",
          "立场决定信息取舍",
        ],
      },
      { type: "h2", text: "第二阶段开始出现的信号" },
      {
        type: "p",
        text: "开始有人逐条比对时间戳、追溯首发账号、指出材料中的矛盾点。这些动作不产生情绪快感，但它们才是让事件收敛的力量。",
      },
      { type: "h2", text: "关注重点应该如何调整" },
      {
        type: "p",
        text: "在第二阶段，与其追问「到底谁对」，不如追问「哪一条信息现在可以被确认」。可确认的信息累积起来，答案往往会自己浮现。",
      },
      {
        type: "quote",
        text: "第一阶段消耗的是情绪，第二阶段消耗的是耐心。愿意进入第二阶段的人越多，事件就越接近收敛。",
      },
    ],
    related: ["timeline-full", "platform-notice", "three-types"],
  },
  {
    id: "statement-word",
    title: "声明里的「已交由律师处理」到底意味着什么",
    category: "statement",
    author: "本站编辑部",
    date: "2026-08-29",
    readTime: "6 分钟",
    excerpt:
      "这句话几乎是每份声明的标配收尾，但它被赋予的含义常常超出它本身。理解这几个法律表述的实际边界，能避免很多误读。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20conceptual%20illustration%2C%20warm%20cream%20paper%20background%2C%20burgundy%20scales%20of%20justice%20and%20gold%20seal%20geometric%20shapes%2C%20minimal%20magazine%20cover%20art%2C%20subtle%20grain%20texture%2C%20flat%20vector%2C%20no%20text%2C%20no%20people&width=1200&height=800&seq=ll-legal-j10&orientation=landscape",
    tags: ["声明解读", "法律表述", "措辞"],
    infoLevel: "已证实",
    content: [
      {
        type: "p",
        text: "法律表述之所以难读，是因为它的严谨性来自「什么也没承诺」。理解这一点，就能看懂声明为什么总是似曾相识。",
      },
      { type: "h2", text: "它表达了什么" },
      {
        type: "p",
        text: "表达了两层意思：一是立场已经确定，不再就细节作公开讨论；二是保留后续采取行动的可能性。它是一种表态，而不是结果。",
      },
      { type: "h2", text: "它没有表达什么" },
      {
        type: "list",
        items: [
          "不代表已经提起诉讼",
          "不代表对方行为已被认定违法",
          "不代表事件已经结束",
        ],
      },
      { type: "h2", text: "如何判断它是否落到了实处" },
      {
        type: "p",
        text: "看后续是否出现可公开查询的程序性信息。如果长期只有声明、没有下文，那么这句话的实际作用仍然停留在公关层面。",
      },
      {
        type: "quote",
        text: "法律表述的分量，不在于它说得多重，而在于它之后是否有人真的走进程序。",
      },
      {
        type: "p",
        text: "对读者来说，把这句表述放回「表态」而非「事实」的类别，是最稳妥的处理方式。本站也会持续关注是否有程序层面的新进展。",
      },
    ],
    related: ["statement-read", "response-five-points", "platform-notice"],
  },
];